'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LifeCycleProvider = require('./LifeCycleProvider');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LifeCycleProvider).default;
  }
});

var _PropToggle = require('./PropToggle');

Object.defineProperty(exports, 'SimpleToggle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PropToggle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-prop-toggle/dist/index.js
// module id = 1161
// module chunks = 0